module.exports = __webpack_public_path__ + "static/media/6.d9d7cbd3.jpg";